// Only update this if the `prod.*.okra.supportedCountryCodesToNames` OkraWebsite supported countries list changes
// https://code.amazon.com/packages/OkraWebsite/blobs/f1bdbe9350920d9c1ed29ec96f8167d4b3b8e11f/--/configuration/brazil-config/global/OkraWebsiteConfig.cfg#
// see CR for details https://code.amazon.com/reviews/CR-93435752/revisions/2#/details
//  Finance/Accounting have asked us to block the creation of resellers in unsupported countries to
//  avoid compliance issues, prevent new manual accounting process and limit tax exposure/risk.

export const COUNTRIES = {
    AE: 'United Arab Emirates',
    AR: 'Argentina',
    AU: 'Australia',
    AT: 'Austria',
    BE: 'Belgium',
    BR: 'Brazil',
    CA: 'Canada',
    CH: 'Switzerland',
    CL: 'Chile',
    CN: 'China',
    CO: 'Colombia',
    DE: 'Germany',
    EG: 'Egypt',
    ES: 'Spain',
    FR: 'France',
    GB: 'United Kingdom',
    IE: 'Ireland',
    IN: 'India',
    IT: 'Italy',
    JP: 'Japan',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MX: 'Mexico',
    NL: 'Netherlands',
    NO: 'Norway',
    NZ: 'New Zealand',
    PA: 'Panama',
    PE: 'Peru',
    PL: 'Poland',
    PT: 'Portugal',
    SA: 'Saudi Arabia',
    SG: 'Singapore',
    US: 'United States',
    ZA: 'South Africa',
};
